module.exports = __webpack_public_path__ + "images/halloween_lp/MV_characters_eeffd1d42e7a5f3e2ee2ac8d08de5030.png";